import { render, staticRenderFns } from "./trash-can.vue?vue&type=template&id=872323fa&functional=true&"
import script from "./trash-can.vue?vue&type=script&lang=js&"
export * from "./trash-can.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports